import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${ColorSF2.white};
  box-shadow: 0 3px 6px ${ColorSF2.transparentShadow};
`;
export const InputTitle = styled.div`
  width: 600px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  background-color: ${ColorSF2.paleBlue};
`;
export const TextBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 40px;
`;
export const PINCodeText = styled.div`
  display: flex;
  width: 360px;
  justify-content: end;
  align-items: center;
`;
export const PINCodeBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;
`;
export const ReissueLink = styled.p`
  color: ${ColorSF2.navyBlue};
  text-decoration: underline;
  cursor: pointer;
  margin: 0;
`;
export const ErrorMessage = styled.p`
  color: ${ColorSF2.alertRed};
  margin: 0;
`;
